import { JstDate } from '../../core/time/business-time';
import { jstCalendarPlugin, calendarNow } from '../../core/time/business-calendar';
import { AfterViewInit, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { PageTitleService } from '../../core/services/page-title.service';
import { InoutService } from '../../core/services/inout.service';
import {
  JAPANESE_HOLIDAY_SOURCE_ID,
  loadJapaneseHolidayEvents,
} from '../../shared/utils/japanese-holiday-calendar';

const INOUT_EVENT_SOURCE_ID = 'inout-history';

@Component({
    selector: 'app-inout',
    imports: [],
    templateUrl: './inout.component.html'
})
export class InoutComponent implements OnInit, AfterViewInit, OnDestroy {
  private pageTitle = inject(PageTitleService);
  private inoutService = inject(InoutService);

  private events: any[] = [];
  private calendar: Calendar | null = null;
  private holidayLoadId = 0;
  current: any = {};

  async ngOnInit(): Promise<void> {
    this.pageTitle.set('fa s-icon-list', '入退館履歴');
    const data = await this.inoutService.get('self', 'all', 'all');
    if (Array.isArray(data)) {
      this.events = data.map(v => ({
        title: !v.isEntrance ? '入館' : '退館',
        start: v.accessedAt,
        color: !v.isEntrance ? 'green' : 'red',
        classNames: !v.isEntrance ? ['in'] : ['out'],
        extendedProps: v,
      }));
      this.refreshInoutEvents();
    }
  }

  ngAfterViewInit(): void {
    const calendarEl = document.getElementById('calendar');
    if (!calendarEl) return;
    this.calendar = new Calendar(calendarEl, {
      plugins: [jstCalendarPlugin, dayGridPlugin, listPlugin, interactionPlugin],
      timeZone: 'Asia/Tokyo', now: calendarNow,
      locale: 'ja',
      firstDay: 0,
      navLinks: false,
      editable: false,
      contentHeight: 'auto',
      defaultTimedEventDuration: '00:00',
      views: { dayGridMonth: { dayMaxEvents: 2 } },
      buttonText: { today: '今日', day: '日', week: '週', month: '月', list: 'リスト' },
      headerToolbar: { center: '', left: 'title today', right: 'dayGridMonth listMonth prev next' },
      datesSet: (info: any) => {
        void this.refreshHolidayEvents(info.start, info.end);
      },
      dateClick: (info: any) => this.calendar?.changeView('dayGridDay', info.dateStr),
      eventClick: (info: any) => {
        if (info.event?._def?.extendedProps?.type === 'holiday') return;
        this.calendar?.changeView('dayGridDay', info.event.startStr);
      },
      moreLinkContent: (args: any) => args.num >= 10 ? '+α' : `+${args.num}件`,
      dayCellContent: (e: any) => e.dayNumberText.replace('日', ''),
      validRange: () => ({ start: '2020-01-01', end: `${new JstDate().getFullYear() + 1}-01-01` }),
      eventSources: [{ id: INOUT_EVENT_SOURCE_ID, events: this.events }],
    });
    this.calendar.render();
  }

  ngOnDestroy(): void {
    this.holidayLoadId++;
    this.calendar?.destroy();
    this.calendar = null;
  }

  private refreshInoutEvents(): void {
    if (!this.calendar) return;
    this.calendar.getEventSourceById(INOUT_EVENT_SOURCE_ID)?.remove();
    this.calendar.addEventSource({ id: INOUT_EVENT_SOURCE_ID, events: this.events });
  }

  private async refreshHolidayEvents(start: Date, end: Date): Promise<void> {
    if (!this.calendar) return;
    const loadId = ++this.holidayLoadId;
    try {
      const events = await loadJapaneseHolidayEvents(start, end);
      if (!this.calendar || loadId !== this.holidayLoadId) return;
      this.calendar.getEventSourceById(JAPANESE_HOLIDAY_SOURCE_ID)?.remove();
      this.calendar.addEventSource({ id: JAPANESE_HOLIDAY_SOURCE_ID, events });
    } catch (error) {
      console.warn('日本祝日カレンダーの取得に失敗しました。', error);
    }
  }
}
